module.exports = __webpack_public_path__ + "img/BOX.3fc04ccd.svg";